import { render, staticRenderFns } from "./TablaPesajes.vue?vue&type=template&id=1d757f03&scoped=true"
import script from "./TablaPesajes.vue?vue&type=script&lang=ts"
export * from "./TablaPesajes.vue?vue&type=script&lang=ts"
import style0 from "./TablaPesajes.vue?vue&type=style&index=0&id=1d757f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d757f03",
  null
  
)

export default component.exports